'use strict';

var GridDemandPostingButtonDirective = function GridDemandPostingButtonDirective($rootScope) {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-demand-posting-button.html'),
    controller: 'GridDemandPostingButtonController',
    link: function link($scope) {
      var saveModalCallbacks = {
        onGridPristine: $scope.enterDemandPosting,
        onNoBtnClick: $scope.gridPanelScope.undo
      };
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows) {
        $scope.onRowSelection(event, selectedRows, gridId, allRows);
      });
      $scope.showDemandPosting = function () {
        $rootScope.$broadcast('save-modal:openModal', null, {
          name: 'market-analysis'
        }, saveModalCallbacks);
      };
    }
  };
};
GridDemandPostingButtonDirective.$inject = ['$rootScope'];
module.exports = GridDemandPostingButtonDirective;